import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/badge.svg'
import _imports_1 from '../../assets/night_shelter.svg'
import _imports_2 from '../../assets/list_add_check.svg'
import _imports_3 from '../../assets/menu.svg'


const _withScopeId = n => (_pushScopeId("data-v-485c9669"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "pointer-link"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "badge",
  height: "15",
  class: "mr-1-1"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "badge",
  height: "15",
  class: "mr-1-1"
}, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: "badge",
  height: "15",
  class: "mr-1-1"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_header = _resolveComponent("el-header")!

  return (_openBlock(), _createBlock(_component_el_header, { class: "primary__dark__color__bg app-header" }, {
    default: _withCtx(() => [
      (_ctx.eventData)
        ? (_openBlock(), _createBlock(_component_el_row, {
            key: 0,
            class: "fill-height",
            type: "flex",
            justify: "space-between",
            align: "middle"
          }, {
            default: _withCtx(() => [
              (_ctx.eventData.themeSettings.logoURL)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("img", {
                      src: _ctx.eventData.themeSettings.logoURL,
                      alt: "event photo",
                      height: "30",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goTo('Home')))
                    }, null, 8, _hoisted_2)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                (_ctx.isLogged && _ctx.type != 'sm')
                  ? (_openBlock(), _createBlock(_component_el_dropdown, { key: 0 }, {
                      dropdown: _withCtx(() => [
                        _createVNode(_component_el_dropdown_menu, { class: "configuration-menu" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_dropdown_item, {
                              disabled: "",
                              id: "configuration-menu__username"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.participantData.name), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('AccountSettings'))),
                              icon: "el-icon-s-tools"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("header.configurationMenu.accountSettings")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo('QRIdentification')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_4,
                                _createTextVNode(" " + _toDisplayString(_ctx.$t("header.configurationMenu.eventId")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo('MyBookings')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5,
                                _createTextVNode(_toDisplayString(_ctx.$t("header.configurationMenu.MyBooking")), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dropdown_item, {
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goTo('Courses')))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6,
                                _createTextVNode(_toDisplayString(_ctx.$t("header.configurationMenu.courses")), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_el_avatar, {
                          class: "mr-1",
                          size: 35,
                          fit: _ctx.cover,
                          src: _ctx.participantPhoto
                        }, null, 8, ["fit", "src"])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("img", {
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.toggleSidebar && _ctx.toggleSidebar(...args))),
                  src: _imports_3,
                  alt: "icon menu",
                  style: {"cursor":"pointer"}
                })
              ])
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}